"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseExcelParts = void 0;
const QuickOrderBlock_1 = require("../Components/Block/QuickOrderBlock/QuickOrderBlock");
const isNum_1 = require("./DataTypes/isNum");
const uniqueId_1 = __importDefault(require("lodash/uniqueId"));
const parseExcelParts = (pasted, partInputs, index) => {
    const rows = pasted.split('\n');
    const pastedParts = [];
    rows.forEach(row => {
        var _a, _b, _c;
        const columns = row.split('\t');
        let newAmount = ((_a = columns[1]) === null || _a === void 0 ? void 0 : _a.length) && (0, isNum_1.isNum)(columns[1]) ? parseInt(columns[1]) : 1;
        if ((columns === null || columns === void 0 ? void 0 : columns.length) === 1) {
            newAmount = (_b = partInputs === null || partInputs === void 0 ? void 0 : partInputs[index]) === null || _b === void 0 ? void 0 : _b.amount;
        }
        if ((_c = columns[0]) === null || _c === void 0 ? void 0 : _c.length) {
            pastedParts.push({
                id: (0, uniqueId_1.default)(`${QuickOrderBlock_1.PART_INPUT}-`),
                partNo: columns[0].trim(),
                amount: newAmount
            });
        }
    });
    return pastedParts;
};
exports.parseExcelParts = parseExcelParts;
